export default __webpack_public_path__ + "static/media/1.1d6c38fd.jpg";